<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Add New Tag</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="12">
            <base-input label="Tag Name"
                        name="name"
                        type="textarea"
                        placeholder="Tag Name"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.name">
            </base-input>
          </b-col>
          <!--b-col md="12">
            <label class="form-control-label">
              Tag Description
            </label>
            <html-editor
              v-model="model.description">
            </html-editor>
          </b-col-->
          <b-col md="2">
            <label class="form-control-label">
              Dietary Tag?
            </label><br />
            <base-switch label="Dietary Tag?"
                    name="isDietary"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isDietary">
            </base-switch>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Active?
            </label><br />
            <base-switch label="Is Active?"
                    name="isActive"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isActive">
            </base-switch>
          </b-col>
        </div>
        <base-button type="primary" @click="addTagSubmit('/tags')">Save and Close</base-button>
        <base-button type="primary" @click="addTagSubmit('/tag/add-tag')">Save and Add Another</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import DropzoneFileUpload from '../../components/Inputs/DropzoneFileUpload.vue';
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import Instructions from '../Components/Instructions.vue';
  import uuid from 'uuid';

  export default {
    name: "AddTag",
    components: {
        HtmlEditor,
        DropzoneFileUpload,
        [Select.name]: Select,
        [Option.name]: Option,
        Instructions
    },
    data() {
      return {
        validated: false,
        model: {
          id: '',
          clientId: '',
          name: '',
          iconId: '0215cb06-0ebb-4b17-098d-08d9269dc513',
          icon: '',
          isDietary: false,
          isActive: true,
          isDeleted: false,
          isVisible: true
        }
      }
    },
    methods: {
      addTagSubmit(goTo) {
        this.model.id = uuid();
        let user = JSON.parse(localStorage.getItem('user'));
        const { dispatch } = this.$store;
        this.model.recipeId = uuid();
        this.model.clientId =  user.clientId;
        if (this.model.name) {
          try {
              dispatch("tags/addTag", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Tag Added'});
                  const { dispatch } = this.$store;
                  dispatch("tags/getAllTags");
                  this.$router.push({path: goTo});
                  this.resetForm();
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: tag add", error);
          }
        }
      },
      addCollectionRow() {
        this.model.collections.push({ id: '' })
      },
      resetForm() {
        this.model.id = '';
        this.model.name = '';
        this.model.description = '';
      }
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
